export const ProvidersIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={19}
    fill="none"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
      d="M12.75 15.125c0-1.243-1.68-2.25-3.75-2.25-2.07 0-3.75 1.007-3.75 2.25m10.5-2.25c0-.922-.925-1.715-2.25-2.063M2.25 12.876c0-.922.925-1.715 2.25-2.063m9-3.01a2.25 2.25 0 1 0-3-3.354m-6 3.354a2.25 2.25 0 0 1 3-3.354M9 10.625a2.25 2.25 0 1 1 0-4.5 2.25 2.25 0 0 1 0 4.5Z"
    />
  </svg>
);
